import web1 from '../../assets/img/web1.webp';
import web2 from '../../assets/img/web2.webp';
import web3 from '../../assets/img/web3.webp';
import linkedin from '../../assets/img/web3link.svg';
import instagram from '../../assets/img/instagram.svg';
import soft1 from '../../assets/img/soft1.webp';
import soft2 from '../../assets/img/soft2.webp';
import soft3 from '../../assets/img/soft3.webp';
import mobile1 from '../../assets/img/mobile1.webp';
import mobile2 from '../../assets/img/mobile2.webp';
import mobile3 from '../../assets/img/mobile3.webp';
import design1 from '../../assets/img/design1.webp';
import design2 from '../../assets/img/design2.webp';
import design3 from '../../assets/img/design3.webp';
import design4 from '../../assets/img/design4.webp';
import design5 from '../../assets/img/design5.webp';
import design6 from '../../assets/img/design6.webp';
import marketing1 from '../../assets/img/marketing1.webp';
import marketing2 from '../../assets/img/marketing2.webp';
import marketing3 from '../../assets/img/marketing3.webp';

const expertsData = (t) => {
  const expertsDataData = {
  webDev: {
    title: 'Web development',
    items: [
      {
        photo: web1,
        name: "Mikalai Hil",
        position: "Frontend Developer",
        link:'https://www.linkedin.com/in/nikolaigil/',
        imageLink: linkedin,
        description: t("web_description1")
      },
      {
        photo: web2,
        name: "Yury Yeramianok",
        position: "Frontend Developer",
        link:'https://www.linkedin.com/in/yura-eremenok-1b9351183/',
        imageLink: linkedin,
        description: t("web_description2")
      },
      {
        photo: web3,
        name: "Yury Moladau",
        position: "Frontend Developer",
        link:'https://www.linkedin.com/in/yury-molodov-03aa11188/',
        imageLink: linkedin,
        description:t("web_description3")
      }

    ]
  },
  software: {
    title: 'Software Development ',
    items: [
      {
        photo: soft1,
        name: "Anastasiya Kamoska",
        position: "QA engineer",
        link:'https://www.linkedin.com/in/kamaj42/',
        imageLink: linkedin,
        description: t("software_description1")
      },
      {
        photo: soft2,
        name: "Gleb Krishin",
        position: "JS engineer",
        link:'https://www.linkedin.com/in/gleb-krishin/',
        imageLink: linkedin,
        description: t("software_description2")
      },
      {
        photo: soft3,
        name: "Uladzislau Estryn",
        link:'https://www.linkedin.com/in/vlad-estrin/',
        position: "Software Engineer",
        imageLink: linkedin,
        description: t("software_description3")
      }

    ]
  },
  mobile: {
    title: 'Mobile Apps',
    items: [
      {
        photo: mobile1,
        name: "Kanstantsin Bucha",
        position: "iOS Developer",
        link:'https://www.linkedin.com/in/kanstantsinbucha/',
        imageLink: linkedin,
        description: t("mobile_description1")
      },
      {
        photo: mobile2,
        name: "Ruslan Filistovich",
        position: "iOS Developer",
        link:'https://www.linkedin.com/in/ruslanfilistovich/',
        imageLink: linkedin,
        description: t("mobile_description2")
      },
      {
        photo: mobile3,
        name: "Vladislav Medvedev",
        position: "QA Engineer",
        link:'https://www.linkedin.com/in/vladislav-medvedev-/',
        imageLink: linkedin,
        description: t("mobile_description3")
      }

    ]
  },
  design: {
    title: 'UX/UI Design ',
    items: [
      {
        photo: design1,
        name: "Valeria Vrublevskaya",
        position: "Brand designer",
        link:'https://instagram.com/vv2brand?igshid=YmMyMTA2M2Y=',
        imageLink: instagram,
        description: t("ux_description1")
      },
      {
        photo: design2,
        name: "Yana Kazlova",
        position: "UI/UX Designer",
        link:'https://www.linkedin.com/in/yana-kozlova-b8b909211/',
        imageLink: linkedin,
        description: t("ux_description2")
      },
      {
        photo: design3,
        name: "Ksenia Kuhnovets",
        position: "Product Designer",
        link:'https://www.linkedin.com/in/ksenia-kuhnovets/',
        imageLink: linkedin,
        description: t("ux_description3")
      },
      {
        photo: design4,
        name: "Anastasia Shevko",
        position: "Graphic / Web-designer",
        link:'https://www.linkedin.com/in/anastasia-shevko-7b0443173/',
        imageLink: linkedin,
        description: t("ux_description4")
      },
      {
        photo: design5,
        name: "Alesia Maksimava",
        position: "Marketing Specialist",
        link:'https://www.linkedin.com/in/alesia-maksimava-9949b5256/',
        imageLink: linkedin,
        description: t("ux_description5")
      },
      {
        photo: design6,
        name: "Valeryia Kamarova",
        position: "Graphic / Web-designer",
        link:'http://linkedin.com/in/valeryia-kamarova-928766247',
        imageLink: linkedin,
        description: t("ux_description6") 
      },

    ]
  },
  marketing: {
    title: 'Marketing',
    items: [
      {
        photo: marketing1,
        name: "Anhelina Tavarevich",
        position: "Marketing Specialist",
        link:'https://www.linkedin.com/in/angelina-towarewicz-765b59271/',
        imageLink: linkedin,
        description: t("marketing_description1")
      },
      {
        photo: marketing2,
        name: "Darya Khmialnitskaya",
        position: "Marketing Specialist",
        link:'https://instagram.com/dashakhmelnitskaya',
        imageLink: instagram,
        description: t("marketing_description2")
      },
      {
        photo: marketing3,
        name: "Alina Dudina",
        position: "Marketing Specialist",
        link:'https://www.instagram.com/alinadudina.vsl/',
        imageLink: instagram,
        description: t("marketing_description3")
      }

    ]
  },
}
return expertsDataData
}

export default expertsData;